import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id D77BE879-A1D5-48F5-9068-B74A2ED4017A
 * name music-rest-eighth
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-rest-eighth.svg
 * tags
 * - Music 
 */
export const MusicRestEighthIcon = createSvgIcon(<><path d="M14 6A5.56 5.56 0 0 1 10.95 7.86A1.5 1.5 0 1 0 9.5 9H9.74A6.32 6.32 0 0 0 13.25 7.93L10 18H12L16 6Z" /></>, 'MusicRestEighthIcon');
export default MusicRestEighthIcon